import { z } from 'zod';

// All entity number unique identifiers are documented here:
// https://schuettflix.atlassian.net/wiki/spaces/Engineerin/pages/1952972805/Entity+Numbers+Unique+Identifiers

export const GenericOrderNumberSchema = z.string().regex(/^(?:DE|AT|CZ|PL)\d{2}[2-9]\d{6}$/, {
    message:
        'Generic order number must follow the format 2 letter country code, 2 digit year + 7 digits, first digit >=2 – e.g. DE262123456',
});

export const LegacyOrderNumberSchema = z.string().regex(/^(?:DE|AT|CZ|PL)\d{2}[0-1]\d{6}$/, {
    message:
        'Legacy order number must follow the format 2 letter country code, 2 digit year + 7 digits, first digit <=1 – e.g. DE260123456',
});

export const OrderNumberSchema = z.union([GenericOrderNumberSchema, LegacyOrderNumberSchema], {
    message: 'Order number must follow the format 2 letter country code, 2 digit year + 7 digits – e.g. DE260123456',
});

export type OrderNumber = z.infer<typeof OrderNumberSchema>;
